import { NgModule } from '@angular/core';
import { AppCommonModule } from 'src/app/app-common/app-common.module';

import { ScannerPrintDetailRoutingModule } from './scanner-print-detail-routing.module';
import { ScannerPrintDetailComponent } from './scanner-print-detail.component';

@NgModule({
  declarations: [ScannerPrintDetailComponent],
  imports: [AppCommonModule, ScannerPrintDetailRoutingModule],
})
export class ScannerPrintDetailModule {}
